import React from 'react'

const DashboardAnnouncements = () => {
  return (
    <div className="dashboard-content">
    <div className="home-heading-container">
      <h1 className="heading-text-h1">Announcements</h1>
    </div>
    <hr className="dashboard-home-hr" />
    </div>
  )
}

export default DashboardAnnouncements